module.exports = __webpack_public_path__ + "img/million-left-size-img.8c038523.png";